import { render } from "./ActiveScreen.vue?vue&type=template&id=0b32c688&scoped=true"
import script from "./ActiveScreen.vue?vue&type=script&lang=js"
export * from "./ActiveScreen.vue?vue&type=script&lang=js"

import "./ActiveScreen.vue?vue&type=style&index=0&id=0b32c688&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_omroepwest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b32c688"]])

export default __exports__